import * as r from 'ramda';
import { Anchor } from 'domain/constants/anchor';
import { Align } from '@uds/grid';

const anchorMap = {
  [Anchor.TOP]: Align.FLEX_START,
  [Anchor.CENTER]: Align.CENTER,
  [Anchor.BOTTOM]: Align.FLEX_END,
};

export type AnchorArray = [Anchor | null, Anchor | null, Anchor | null];
export default (defaultAnchors: AnchorArray, desiredAnchors: AnchorArray | undefined) => {
  return r.pipe(
    r.defaultTo([null, null, null]),
    r.zipWith((a: Anchor, b: Anchor) => {
      if (b == null) {
        return anchorMap[a];
      }

      return anchorMap[b];
    }, defaultAnchors),
  )(desiredAnchors) as unknown as AnchorArray;
};
